import React, { Suspense, useState, useEffect } from 'react';
import _ from 'lodash';
import withAuthentication from '../../hoc/withAuthentication';

import Spinner from '../../components/Spinner/Spinner';
import { useTransactionDocumentLookupsStore } from '../../store/providers/TransactionDocumentLookups';

const DocumentMapper = (props) => {

    const { data, getSmartDocMapperToken } = useTransactionDocumentLookupsStore();
    const [isMounted, setIsMounted] = useState(false);
    const [baseUrl, setBaseUrl] = useState('');
    const [token, setToken] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (!isMounted || data?.scope !== 'mapperToken') {
            return;
        }

        if (!_.isEmpty(data)) {
            const hasToken = data.status === 'success' && typeof data.body === 'string' && data.body.trim().length > 0;

            setToken(hasToken ? `?token=${data.body}` : null);
            setIsLoaded(hasToken);
        }

    }, [data, isMounted]);


    useEffect(() => {
        if (isMounted) {
            return;
        }

        getSmartDocMapperToken();

        let base_url = process.env.REACT_APP_SMART_DOC_WEB_BASE;
        if (process.env.REACT_APP_ENV === 'staging') {
            base_url = process.env.REACT_APP_SMART_DOC_WEB_STAGING;
        } else if (process.env.REACT_APP_ENV === 'test') {
            base_url = process.env.REACT_APP_SMART_DOC_WEB_TEST;
        } else if (process.env.REACT_APP_ENV === 'production') {
            base_url = process.env.REACT_APP_SMART_DOC_WEB_PRODUCTION;
        }
        setBaseUrl(base_url);
        setIsMounted(true);
    }, [isMounted, baseUrl, getSmartDocMapperToken]);

    return (
        <Suspense fallback={<Spinner text="Loading Document Mapper..." />}>
            {
                !isLoaded && <Spinner text="Loading Document Mapper..." />
            }
            {isLoaded &&
                <div>
                    <iframe id="doc-map-iframe" title="Document Mapper"
                        style={{ width: '100%', height: 'Calc(100vh - 15px)', borderWidth: '0px' }}
                        src={`${baseUrl}/document-mapper/${props.documentId}/${props.instanceId}${token ?? ''}`}>
                    </iframe>
                </div>
            }
        </Suspense>
    )
}

export default withAuthentication(DocumentMapper);